import api from './axios';

const EndPoints = {
	join(id:string) {
		return `/merchant/settings/team/${id}/join`;
	},
	marketSetting: '/merchant/market-setting',
};

export const joinViaInvite = async (id:string, payload:unknown) => {
	const res = await api.post(EndPoints.join(id), payload);
	return res;
};

export type CreateMarketSettingPayload = {
	supportedPairId: string;
	/** Buy-side offset type: FLAT | MANUAL | PERCENTAGE */
	offset: string;
	/** Sell-side offset type: FLAT | MANUAL | PERCENTAGE */
	sellingOffset?: string;
	buying: number;
	selling: number;
};

export const createMarketSetting = async (payload: CreateMarketSettingPayload) => {
	const res = await api.post(EndPoints.marketSetting, payload);
	return res;
};

export const getMarketSetting = async (id: string) => {
	const res = await api.get(`${EndPoints.marketSetting}/${id}`);
	return res;
};

export const updateMarketSetting = async (id: string, payload: Partial<CreateMarketSettingPayload>) => {
	const res = await api.patch(`${EndPoints.marketSetting}/${id}`, payload);
	return res;
};

export const deleteMarketSetting = async (id: string) => {
	const res = await api.delete(`${EndPoints.marketSetting}/${id}`);
	return res;
};
